export default __webpack_public_path__ + "static/media/ETEF-18-19.ceca599b.pdf";